import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { defaultColorPalettes } from '../components/_ui/shared/Colors.g';
import { ReceiptSettings, Theme } from '../stores/types';
import { ColorPaletteObject } from '../stores/types/theme.interface';
import { header } from './http/http.service';

// More info about RTK Query
// https://redux-toolkit.js.org/rtk-query/overview

export const envApi = createApi({
  reducerPath: 'env',
  baseQuery: fetchBaseQuery({
    headers: header,
    baseUrl: '/',
  }),
  endpoints: (builder) => ({
    fetchThemeSettings: builder.query<Theme, void>({
      query: () => `assets?resourceId=theme&domainName=${window.location.hostname}`,
      transformResponse: (response: {
        primary_color: string;
        secondary_color: string;
        brand_0: string;
        brand_1: string;
        brand_2: string;
        brand_3: string;
        color_palettes: ColorPaletteObject;
        default_language?: string;
      }) => ({
        // logo will be determined based on the domain
        networkLogo: `/assets?resourceId=logo-svg&domainName=${window.location.hostname}`,
        chartColor: response.primary_color,
        navigationSelectedColor: response.primary_color,
        btnHoverColor: response.brand_3,
        secondaryBtnBgColor: response.secondary_color,
        brand_0: response.brand_0,
        brand_1: response.brand_1,
        brand_2: response.brand_2,
        brand_3: response.brand_3,
        colorPalettes:
          response.color_palettes?.denim ||
          response.color_palettes?.ink ||
          defaultColorPalettes.denim,
        default_language: response.default_language,
      }),
    }),
    fetchReceiptSettings: builder.query<ReceiptSettings, void>({
      query: () => `assets?resourceId=receipt-settings&domainName=${window.location.hostname}`,
    }),
  }),
});

export const { useFetchThemeSettingsQuery, useFetchReceiptSettingsQuery } = envApi;

// Possible exports
// export const { endpoints, reducerPath, reducer, middleware } = envApi
